const sitemap = {
  'sitemap.page.backToTop': 'Back to top',
  'sitemap.page.lastUpdated': 'Last updated: 13 June 2026',
  'sitemap.page.homeLink': 'Home',
  'sitemap.page.currentPage': 'Sitemap',

  'sitemap.hero.homeLink': 'Home',
  'sitemap.hero.currentPage': 'Sitemap',
  'sitemap.hero.title': 'Sitemap',
  'sitemap.hero.titleEn': 'SITEMAP',
  'sitemap.hero.lead': 'A complete directory of all pages on the Japan Butler Academy website, organised by section for easy navigation.',
  'sitemap.hero.imgAlt': 'The Japan Butler Academy — sitemap',

  'sitemap.content.label': 'PAGES',
  'sitemap.content.title': 'All Pages',
  'sitemap.content.subtitleEn': 'All Pages',
  'sitemap.content.lead': 'Jump directly to any section of the site.',

  'sitemap.faq.label': 'FAQ',
  'sitemap.faq.title': 'Frequently Asked Questions',
  'sitemap.faq.subtitleEn': 'Frequently Asked Questions',
  'sitemap.faq.0.q': 'What if I cannot find the page I am looking for?',
  'sitemap.faq.0.a': 'Please use our enquiry form — a team member will be happy to point you in the right direction.',
  'sitemap.faq.1.q': 'Is there an English version of the site?',
  'sitemap.faq.1.a': 'Yes. Use the language toggle at the top of the page to switch to English.',
  'sitemap.faq.2.q': 'A page is showing outdated information — what should I do?',
  'sitemap.faq.2.a': 'Try clearing your browser cache or refreshing the page. If the issue persists, please contact us.',

  'sitemap.cta.label': 'GET STARTED',
  'sitemap.cta.title': 'Ready to Take the First Step?',
  'sitemap.cta.subtitleEn': 'Take the First Step',
  'sitemap.cta.lead': 'Request a free brochure, book a consultation, or try a taster session — all free of charge.',
  'sitemap.cta.btn': 'Contact Us / Request a Brochure',

  'sitemap.sec.about.title': 'About the Academy',
  'sitemap.sec.about.desc': 'The academy overview, educational philosophy, organisational structure, facilities, and how to find us.',
  'sitemap.sec.courses.title': 'Courses',
  'sitemap.sec.courses.desc': 'Our three main courses and the annual schedule — choose the programme that suits your goals.',
  'sitemap.sec.curriculum.title': 'Curriculum',
  'sitemap.sec.curriculum.desc': 'A detailed look at the learning journey, practical training, study materials, and skills acquired.',
  'sitemap.sec.pricing.title': 'Pricing & Benefits',
  'sitemap.sec.pricing.desc': 'A full fee breakdown, course benefits, and details of the association-recognised certificate awarded on completion.',
  'sitemap.sec.admission.title': 'Admission',
  'sitemap.sec.admission.desc': 'Enrolment process, eligibility requirements, application form, consultation booking, and taster sessions.',
  'sitemap.sec.contact.title': 'Contact',
  'sitemap.sec.contact.desc': 'Enquiry form, brochure request, and corporate training enquiries.',
  'sitemap.sec.corporate.title': 'Corporate Training',
  'sitemap.sec.corporate.desc': 'Sector-specific corporate hospitality training programmes.',
  'sitemap.sec.info.title': 'Information & Media',
  'sitemap.sec.info.desc': 'Blog articles, news announcements, and the latest updates from the academy.',
  'sitemap.sec.legal.title': 'Legal Information',
  'sitemap.sec.legal.desc': 'Privacy Policy, Terms of Service, and mandatory commercial disclosure.',
  'sitemap.sec.other.title': 'Other',
  'sitemap.sec.other.desc': 'News announcements and other pages related to using this website.',

  // Link labels per section
  'sitemap.sec.about.link.0': 'Academy Overview',
  'sitemap.sec.about.link.1': 'Educational Philosophy',
  'sitemap.sec.about.link.2': 'The All Japan Butler Association',
  'sitemap.sec.about.link.3': 'Facilities & Equipment',
  'sitemap.sec.about.link.4': 'Access',
  'sitemap.sec.about.link.6': "President's Message",

  'sitemap.sec.courses.link.0': 'Courses Overview',
  'sitemap.sec.courses.link.1': 'Essential Course',
  'sitemap.sec.courses.link.2': 'Advanced Course',
  'sitemap.sec.courses.link.3': 'Master Course',
  'sitemap.sec.courses.link.4': 'Annual Schedule',

  'sitemap.sec.curriculum.link.0': 'Curriculum Overview',
  'sitemap.sec.curriculum.link.1': 'Practical Training',
  'sitemap.sec.curriculum.link.2': 'Study Materials',
  'sitemap.sec.curriculum.link.3': 'Skills Acquired',

  'sitemap.sec.pricing.link.0': 'Pricing Overview',
  'sitemap.sec.pricing.link.1': 'Detailed Course Fees',
  'sitemap.sec.pricing.link.2': 'Course Benefits',
  'sitemap.sec.pricing.link.3': 'Certificate & Qualification',

  'sitemap.sec.admission.link.0': 'Admission Overview',
  'sitemap.sec.admission.link.1': 'Eligibility & Application Process',
  'sitemap.sec.admission.link.2': 'Application Form',
  'sitemap.sec.admission.link.3': 'Book a Consultation',
  'sitemap.sec.admission.link.4': 'Taster Session',

  'sitemap.sec.contact.link.0': 'Contact',
  'sitemap.sec.contact.link.1': 'FAQ',
  'sitemap.sec.contact.link.2': 'Brochure Request',
  'sitemap.sec.contact.link.3': 'Corporate Training',
  'sitemap.sec.contact.link.4': 'Instructor Blog',

  'sitemap.sec.corporate.link.0': 'Hotel & Ryokan',
  'sitemap.sec.corporate.link.1': 'Luxury Residences',
  'sitemap.sec.corporate.link.2': 'Finance & Private Banking',
  'sitemap.sec.corporate.link.3': 'Department Stores & Luxury Retail',
  'sitemap.sec.corporate.link.4': 'Luxury Sales',
  'sitemap.sec.corporate.link.5': 'Healthcare & Beauty Clinics',
  'sitemap.sec.corporate.link.6': 'Automotive & Mobility',
  'sitemap.sec.corporate.link.7': 'Chauffeur & Private Transfer',

  'sitemap.sec.other.link.0': 'News',
};

export default sitemap;
